/**
 * Valida CPF brasileiro via algoritmo modulo 11 (digitos verificadores).
 *
 * Implementacao 1:1 com o `_validar_cpf` do backend em
 * `app/services/societario/documento_extractor.py` — mesma logica, mesma
 * rejeicao de CPFs sequenciais (000.000.000-00, 111.111.111-11, etc.).
 *
 * Usado no wizard de criar contrato pra exibir warning visual quando a
 * IA extrai um CPF que falha modulo 11 (operador re-checa contra o
 * documento original via "Ver documento").
 */
export function validarCpf(cpf: string | null | undefined): boolean {
  if (!cpf) return false;
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) return false;
  if (new Set(digits).size === 1) return false;

  // DV1: pesos 10..2 sobre digitos 0..8
  let soma = 0;
  for (let i = 0; i < 9; i += 1) soma += parseInt(digits[i], 10) * (10 - i);
  let resto = soma % 11;
  const dv1 = resto < 2 ? 0 : 11 - resto;
  if (dv1 !== parseInt(digits[9], 10)) return false;

  // DV2: pesos 11..2 sobre digitos 0..9
  soma = 0;
  for (let i = 0; i < 10; i += 1) soma += parseInt(digits[i], 10) * (11 - i);
  resto = soma % 11;
  const dv2 = resto < 2 ? 0 : 11 - resto;
  return dv2 === parseInt(digits[10], 10);
}

export default validarCpf;
